@import '~style-sheet-helpers/core.less';
@import '../app-brand/entities/entity-layer.module.less';
@import '../constants/spacing.module.less';

.grid-page {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}

.left-nav {
  position: relative;
  z-index: 2;
  width: 235px;
  background: @left-nav--background-color;
  color: @left-nav--expander--text-color;
}

.main-content {
  z-index: 1;
  position: relative;
  flex: 1 1 100%;
  overflow-x: hidden;
  background: @grid-page--main-content--background-color;
  display: flex;
  flex-direction: column;
}

.grid-header {
  display: flex;
  background-color: @grid-page--grid-header--background-color;
  justify-content: space-between;
}

.grid-content {
  flex-grow: 1;
  display: flex;
  height: calc(100% ~'-' 180px);
  overflow-y: hidden;
}

.grid-and-footer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: calc(100% ~'-' 446px);

  &.no-sidebar {
    max-width: 100%;
  }
}

.grid {
  flex-grow: 1;
  width: 100%;
  height: calc(100% ~'-' 42px);
  position: relative;
}

.paging-footer {
  min-height: 42px;
}

.side-bar {
  width: 446px;
  border-left: 1px solid @grid-page--side-bar--border-color;
}

.edit-grid-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  border-bottom: 1px solid @grid-page--edit-grid-wrap--border-color;
}
.edit-grid-wrap-no-filters {
  border-top: 1px solid @grid-page--edit-grid-wrap--border-color;
}

.grid-filter-wrap {
  display: flex;
  align-items: center;
  background-color: @grid-page--grid-filter-wrap--background-color;
  justify-content: space-between;
  padding: 5px 10px;
}

.tooltip-text {
  max-width: 300px;
}

.learnMoreLink {
  display: flex;
  align-items: center;
}

.learnMoreIcon {
  margin-left: @space-4;
  height: 12px;
  width: 12px;
}

.time-stamp {
  color: var(--grey-500);
  padding: @space-0 @space-12;
}

.grid-header-with-time-stamp {
  align-items: baseline;
  padding: @space-12 @space-0;
  background-color: var(--grey-100);
}
